/**
 * Returns a callback to reset the search input.
 * @param {Element} component
 * @returns {Function}
 */
const handleInputReset = (component) => () => {
    $(component).find('.search__input').val('');
};

export default handleInputReset;



// WEBPACK FOOTER //
// ./src/scripts/components/search/handleInputReset.js